export function rowAnimation() {
    var elements = document.querySelectorAll('.row-parent');
    elements.forEach(function (element) {
        element.classList.add('will-animate');
        var observer = new IntersectionObserver(function (entries) {
            if (entries[0].isIntersecting) {
                element.classList.add('animation');
            }
        });
        observer.observe(element);
    });
}
